var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-area"},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-icon',{staticClass:"icon"},[_vm._v("mdi-information-outline")]),_c('p',[_vm._v(_vm._s(_vm.alertText))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }